import React from 'react';
import { type CatalogProperty, PropertyOperation } from 'src/api/generated';
import { Text } from 'src/modules/shared/components/atoms/text';
import type { TranslationKey } from 'src/modules/shared/types/i18n/translation-keys.type';

type TranslateFn = (
  key: TranslationKey,
  params?: Record<string, string>
) => string;

interface PropertyPricingCardProps {
  property: CatalogProperty;
  salePrice: string | null;
  rentPrice: string | null;
  commonExpenses: string | null;
  t: TranslateFn;
}

export const PropertyPricingCard: React.FC<PropertyPricingCardProps> = ({
  property,
  salePrice,
  rentPrice,
  commonExpenses,
  t,
}) => (
  <div className="rounded-2xl border border-slate-200 bg-slate-50 p-3.5 lg:justify-self-end lg:w-full lg:max-w-[240px]">
    <Text size="tiny" weight="medium" className="text-slate-500">
      {t('catalog.properties.table.price')}
    </Text>
    <div className="mt-2 space-y-1">
      {salePrice ||
      property.operation === PropertyOperation.SALE ||
      property.operation === PropertyOperation.SALE_AND_RENT ? (
        <Text size="small" weight="medium" className="text-slate-900">
          {t('catalog.properties.price.saleLabel')}:{' '}
          <span className={salePrice ? '' : 'text-slate-400'}>
            {salePrice ?? '-'}
          </span>
        </Text>
      ) : null}
      {rentPrice ||
      property.operation === PropertyOperation.RENT ||
      property.operation === PropertyOperation.TEMPORARY_RENT ||
      property.operation === PropertyOperation.SALE_AND_RENT ? (
        <Text size="small" weight="medium" className="text-slate-900">
          {t('catalog.properties.price.rentLabel')}:{' '}
          <span className={rentPrice ? '' : 'text-slate-400'}>
            {rentPrice ?? '-'}
          </span>
        </Text>
      ) : null}
      {!salePrice &&
      !rentPrice &&
      property.operation === PropertyOperation.SALE_AND_RENT ? (
        <Text size="small" className="text-slate-500">
          {t('catalog.properties.price.saleLabel')}:{' '}
          <span className="text-slate-400">-</span> ·{' '}
          {t('catalog.properties.price.rentLabel')}:{' '}
          <span className="text-slate-400">-</span>
        </Text>
      ) : null}
      {!salePrice && !rentPrice && property.operation == null ? (
        <Text size="small" className="text-slate-400">
          -
        </Text>
      ) : null}
      {commonExpenses ? (
        <Text size="tiny" className="text-slate-500">
          {t('catalog.properties.table.commonExpenses')}: {commonExpenses}
        </Text>
      ) : null}
    </div>
  </div>
);
